var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import styles from './comment-form.styles';
import '../../atoms/icon-button/icon-button.js';
import '@shoelace-style/shoelace/dist/components/select/select.js';
import { customElement, property, query, state } from 'lit/decorators.js';
import { serialize } from '@shoelace-style/shoelace/dist/utilities/form.js';
import '../../atoms/button/button.js';
import '@shoelace-style/shoelace/dist/components/option/option.js';
import '@shoelace-style/shoelace/dist/components/input/input.js';
import '@shoelace-style/shoelace/dist/components/textarea/textarea.js';
import '../../atoms/day-selector/day-selector.js';
import { classMap } from 'lit/directives/class-map.js';
import { DateHelpers } from '../../helpers/dateHelpers';
import { SgdfFormElement } from '../../internal/sgdf-element';
import { formKey, getFormSchema } from '../comment.form';
import { validateKey } from '../../internal/validate-key';
import { when } from 'lit/directives/when.js';
import '../../atoms/icon/icon';
import { ifDefined } from 'lit/directives/if-defined.js';
import { withResizeObserver } from '../../internal/with-resize-observer';
let SgdfCommentForm = class SgdfCommentForm extends withResizeObserver(SgdfFormElement) {
    constructor() {
        super(...arguments);
        this.defaultDate = new Date();
        this.defaultType = 'observation';
        this.defaultTags = [];
        this.defaultText = '';
        this.isLoading = false;
        this.noIntro = false;
        this.displayCancel = false;
        this.cancelText = 'Annuler';
        this.clearText = 'Effacer';
        this.submitText = 'Publier';
        this.selectedDate = new Date();
    }
    connectedCallback() {
        super.connectedCallback();
        this.onSubmit = this.onSubmit.bind(this);
        this.sync = this.sync.bind(this);
        this.onSelectDate = this.onSelectDate.bind(this);
        this.updateComplete.then(() => {
            this.form.addEventListener('submit', this.onSubmit);
            this.daySelector.addEventListener('sgdf-select-date', this.onSelectDate);
            this.sync();
        });
    }
    onSelectDate(e) {
        this.selectedDate = e.detail.date;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    handleCancel() {
        this.fieldErrors = {};
        this.emit('sgdf-click:cancel');
    }
    sync() {
        this.selectedDate = DateHelpers.isBetween(this.startDate, this.endDate, this.defaultDate)
            ? this.defaultDate
            : this.defaultDate < this.startDate
                ? this.startDate
                : this.endDate;
    }
    handleClear() {
        this.form.reset();
        this.defaultDate = new Date();
        this.timeSelector.value = this.defaultDate.toLocaleTimeString('fr-FR', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        });
        this.tagPicker.selectedTags = [];
        this.fieldErrors = {};
    }
    async onSubmit(e) {
        var _a;
        e.preventDefault();
        const detail = serialize(this.form);
        const [hours, min] = (_a = detail['time']) === null || _a === void 0 ? void 0 : _a.split(':');
        this.selectedDate.setHours(Number(hours), Number(min));
        const schema = getFormSchema(this.startDate, this.endDate);
        const result = schema.safeParse(Object.assign(Object.assign({}, detail), { date: this.selectedDate, tags_id: this.tagPicker.selectedTags.map(tag => tag.id) }));
        if (result.success) {
            this.emit('sgdf-comment:create', {
                detail: result.data,
            });
            this.handleClear();
        }
        else {
            this.fieldErrors = result.error.formErrors.fieldErrors;
        }
    }
    render() {
        var _a, _b, _c;
        return html `
            <form class="form" @submit=${(e) => e.preventDefault()}>
                ${when(!this.noIntro, () => html `
                        <div class="intro">
                            <p class="detail">
                                L'évaluation permet l'émission d'un avis
                                objectif sur des capacités montrées, basé sur
                                des faits observés, et non une validation ou un
                                jugement de la personne.
                            </p>
                        </div>
                    `)}

                <div class="comment-form">
                    <div class="date">
                        <sgdf-day-selector
                            class="day-selector"
                        .startDate=${this.startDate}
                        .endDate=${this.endDate}
                            .selectedDate=${this.selectedDate}
                        ></sgdf-day-selector>
                        <sl-input
                            name="time"
                            class=${classMap({
            'time-selector': true,
            'form-error': this.fieldHasError(formKey.date),
        })}
                            id="time"
                            type="time"
                            label="Heure :"
                            .disabled=${this.isLoading}
                            .value=${this.defaultDate.toLocaleTimeString('fr-FR', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        })}
                        >
                            <small slot="help-text"
                                >${this.readFieldErrors(formKey.date)}</small
                            >
                        </sl-input>
                    </div>
                    <sl-select
                        class="obs-type"
                        name="type"
                        id="type"
                        placeholder="Type"
                        value=${ifDefined(((_a = this.comment) === null || _a === void 0 ? void 0 : _a.type) || this.defaultType)}
                        .disabled=${this.isLoading}
                    >
                        <sl-option value="observation">Observation</sl-option>
                        <sl-option value="prep_entretien"
                            >Préparation d'entretien</sl-option
                        >
                        <sl-option value="entretien"
                            >Compte-rendu d'entretien</sl-option
                        >
                    </sl-select>

                    <sl-textarea
                        autofocus
                        label="Texte :"
                        .disabled=${this.isLoading}
                        class=${classMap({
            text: true,
            'form-error': this.fieldHasError(formKey.text),
        })}
                        name=${validateKey()(formKey.text)}
                        id=${formKey.text}
                        value=${((_b = this.comment) === null || _b === void 0 ? void 0 : _b.text) || this.defaultText}
                        ?disabled=${this.isLoading}
                    >
                        <small slot="help-text">
                            ${this.readFieldErrors(formKey.text)}
                        </small>
                    </sl-textarea>

                    <sgdf-comment-tag-picker
                        class=${classMap({
            'tag-picker': true,
            'form-error': this.fieldHasError(formKey.tags_id),
        })}
                        .selectedTags=${ifDefined(((_c = this.comment) === null || _c === void 0 ? void 0 : _c.tags) || this.defaultTags)}
                        .commentTags=${this.commentTags}
                    ></sgdf-comment-tag-picker>

                    <div class="footer">
                        ${when(this.displayCancel, () => html `<div class="cancel">
                                    <sgdf-button
                                        neutral
                                        outlined
                                        .loading=${this.isLoading}
                                        @click=${this.handleCancel}
                                        >${this.cancelText}</sgdf-button
                                    >
                                </div>`)}

                        <div class="clear">
                            <sgdf-button
                                danger
                                outlined
                                .loading=${this.isLoading}
                                @click=${this.handleClear}
                                >${this.clearText}</sgdf-button
                            >
                        </div>

                        <div class="submit">
                            <sgdf-button
                                submit
                                primary
                                .loading=${this.isLoading}
                                @click=${this.onSubmit}
                                >${this.submitText}</sgdf-button
                            >
                        </div>
                    </div>
                </div>
            </form>
        `;
    }
};
SgdfCommentForm.styles = styles;
__decorate([
    property({ type: Array, reflect: true })
], SgdfCommentForm.prototype, "commentTags", void 0);
__decorate([
    property({ type: Object, reflect: true })
], SgdfCommentForm.prototype, "comment", void 0);
__decorate([
    property({ type: Object, reflect: true })
], SgdfCommentForm.prototype, "startDate", void 0);
__decorate([
    property({ type: Object, reflect: true })
], SgdfCommentForm.prototype, "endDate", void 0);
__decorate([
    property({ type: Object, reflect: true })
], SgdfCommentForm.prototype, "defaultDate", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfCommentForm.prototype, "defaultType", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfCommentForm.prototype, "defaultTags", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfCommentForm.prototype, "defaultText", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfCommentForm.prototype, "isLoading", void 0);
__decorate([
    property({ reflect: true, type: Boolean, attribute: 'no-intro' })
], SgdfCommentForm.prototype, "noIntro", void 0);
__decorate([
    property({ reflect: true, type: Boolean, attribute: 'display-cancel' })
], SgdfCommentForm.prototype, "displayCancel", void 0);
__decorate([
    property({ type: String })
], SgdfCommentForm.prototype, "cancelText", void 0);
__decorate([
    property({ type: String })
], SgdfCommentForm.prototype, "clearText", void 0);
__decorate([
    property({ type: String })
], SgdfCommentForm.prototype, "submitText", void 0);
__decorate([
    query('.form')
], SgdfCommentForm.prototype, "form", void 0);
__decorate([
    query('.tag-picker')
], SgdfCommentForm.prototype, "tagPicker", void 0);
__decorate([
    query('.day-selector')
], SgdfCommentForm.prototype, "daySelector", void 0);
__decorate([
    query('.datetime-picker')
], SgdfCommentForm.prototype, "datetimePicker", void 0);
__decorate([
    query('.time-selector')
], SgdfCommentForm.prototype, "timeSelector", void 0);
__decorate([
    state()
], SgdfCommentForm.prototype, "selectedDate", void 0);
SgdfCommentForm = __decorate([
    customElement('sgdf-comment-form')
], SgdfCommentForm);
export { SgdfCommentForm };
//# sourceMappingURL=comment-form.js.map